export default {
  "schedule.priceRuleTemplate": "価格ルールテンプレート",
  "schedule.plsSelectPriceRuleTemplate": "価格ルールテンプレートを選択してください",
  "schedule.plsAddSchedule": "スケジュールを追加してください",
  "schedule.addTo": "スケジュール追加",
  "schedule.displayMethod": "表示方法",
  "schedule.allWorks": "すべての作品",
  "schedule.allScreenStandards": "すべてのスクリーン規格",
  "schedule.allSubtitles": "すべての字幕/吹替",
  "schedule.otherVersions": "他のバージョン",
  "schedule.screens": "すべてのスクリーン",
  "schedule.openingTime": "開場時間",
  "schedule.plsInputOpeningTime": "開場時間を入力してください",
  "schedule.endingTime": "終了時間",
  "schedule.plsInputEndingTime": "終了時間を入力してください",
  "schedule.trailer_minutes": "予告編（分）",
  "schedule.preliminaryScreening": "先行上映",
  "schedule.dupSchedule": "スケジュール一括作成",
  "schedule.repeatInterval": "繰り返す間隔",
  "schedule.daily": "日ごと",
  "schedule.weekly": "週間ごと",
  "schedule.repetition": "繰り返し",
  "schedule.reflectionTime": "反映時間",
  "schedule.plsCheckRuleTemplate": "ルールテンプレートを確認してください",
  "schedule.freeSeat": "自由席",
  "schedule.plsSelectHouse": "スクリーンを選んでください",
  "schedule.plsEnterTrailerTime": "予告編（分）を入力してください",
  "schedule.individualSetting": "ルールテンプレート個別設定",
  "schedule.date":"日付",
  "schedule.add": "スケジュール作成",
  "schedule.trailer(min)": "予告編(分)",
  "schedule.plsInputReleaseDate": "上映日を入力してください",
  "schedule.plsInputTrailer(min)": "予告編(分)を入力してください",
  "schedule.table.endTime": "上映終了",
  "schedule.table.detailSetting": "詳細設定",
  "schedule.table.plsSelectHouse": "自由入力か絞り込みで選択してください",
  "schedule.table.plsSelectRuleTempalte": "上映会テンプレートを選択してください",
  "schedule.table.addRow": "上映時間を追加する",
  "schedule.table.submit": "入力内容を承認待ちスケジュールとして追加する",
  "schedule.table.allReset": "入力内容を全てリセット",
  "schedule.table.plsSelectSchedule": "スケジュールを選択してください",
  "schedule.table.plsSelectScreen": "スクリーンを選択してください",
  "schedule.table.plsInputStartTime": "上映時間を選択してください",
  "schedule.table.plsInputEndTime": "上映終了を選択してください",
  "schedule.table.plsSelectRuleTemplate": "上映会テンプレートを選択してください",
  "schedule.form.commandInput": "コマンド入力",
  "schedule.form.plsSelectCommandInput": "コマンド入力を入力してください",
  "schedule.movieShowTime": "上映開始時間",
  "schedule.version": "バージョン",
  "schedule.linkageCsvExport": "連携CSV",
  "schedule.linkageTarget": "連携先",
  "schedule.linkageTargetTms": "TMS連携",
  "schedule.linkageTargetCinemaphone": "シネマフォン連携",
  "schedule.exportFile": "出力ファイル",
  "schedule.dateRange": "日付範囲",
  "schedule.downloadCsv": "CSVダウンロード",
  "schedule.dateRangeMax31Days": "日付範囲は最大31日間です",
  "schedule.noDataForExport": "エクスポートするデータがありません",
};